// apps/admin/src/pages/BulkUpload/utils/richTextToMarkdown.ts
import type ExcelJS from 'exceljs';

const LINK_COLOR = 'FF0563C1';
const URL_COLOR = 'FF808080';

export function richTextToMarkdown(value: ExcelJS.CellValue): string {
  if (value === null || value === undefined) return '';

  if (typeof value === 'object') {
    if ('richText' in value && Array.isArray((value as ExcelJS.CellRichTextValue).richText)) {
      return convertRichText((value as ExcelJS.CellRichTextValue).richText);
    }
    if ('hyperlink' in value && 'text' in value) {
      const hv = value as ExcelJS.CellHyperlinkValue;
      return `[${hv.text}](${hv.hyperlink})`;
    }
    return String(value);
  }

  return String(value);
}

function isLinkRun(run: ExcelJS.RichText): boolean {
  return (
    run.font?.color?.argb === LINK_COLOR &&
    (run.font?.underline === true || run.font?.underline === 'single')
  );
}

function isUrlRun(run: ExcelJS.RichText): boolean {
  return run.font?.color?.argb === URL_COLOR;
}

function convertRichText(runs: ExcelJS.RichText[]): string {
  let result = '';

  for (let i = 0; i < runs.length; i++) {
    const run = runs[i];

    if (isLinkRun(run)) {
      const nextRun = i + 1 < runs.length ? runs[i + 1] : null;
      if (nextRun && isUrlRun(nextRun)) {
        const linkText = run.text;
        const url = nextRun.text.replace(/^\n/, '').replace(/\n$/, '');
        result += `[${linkText}](${url})`;
        if (nextRun.text.endsWith('\n')) {
          result += '\n';
        }
        i++;
        continue;
      }
    }

    let text = run.text;

    if (run.font?.bold) {
      text = text.replace(/([^\n]+)/g, '**$1**');
    }

    text = text.replace(/^• /gm, '- ');
    text = text.replace(/\n• /g, '\n- ');

    text = text.replace(/^ {2}(\d+\. )/gm, '$1');
    text = text.replace(/\n {2}(\d+\. )/g, '\n$1');

    result += text;
  }

  return result.replace(/\n$/, '');
}
